import React from 'react';

class MainSideBar extends React.Component {

	render() {
		return (
			<aside className="main-sidebar">
				<section className="sidebar">
					{ this.props.children }
				</section>
			</aside>
		);
	}
}
export default MainSideBar;